module.exports = __webpack_public_path__ + "assets/images/frch2/4.jpg";